<template>
  <div>
    <!--ヘッダー-->
    <div class="sticky-top">
      <!-- 日付 -->
      <div class="AplicationRegist_DispDateArea d-flex">
        <div class="ChangeTargetDateButton"><b-icon icon="chevron-left" @click="clickBeforeDate()"></b-icon></div>
        <div class="DispYearMonthDate DispYearMonthDateApplicationRegist my-auto">
          {{ dispDate }} ({{ dispDayOfWeek }}) <span class="pl-2">{{ dispDateType }}</span>
        </div>
        <div class="ChangeTargetDateButton"><b-icon icon="chevron-right" @click="clickNextDate()"></b-icon></div>
        <b-button size="sm" variant="transparent" to="/WorkCalendar" class="workCalendarIcon" >
          <b-icon icon="calendar3" variant="primary"></b-icon>
        </b-button>
      </div>
      <!-- 検索 -->
      <div class="WorkM_OwnApplicationListCondition py-2 px-3">
        <b-form-radio-group id="rdog_viewApprovalStatus" v-model="viewApprovalStatus" button-variant="outline-primary" size="sm" buttons @change="getApplicationRegistInfo()">
          <b-form-radio :value=null>すべて</b-form-radio>
          <label class="spacer"></label>
          <b-form-radio :value=0>未承認のみ</b-form-radio>
          <label class="spacer"></label>
          <b-form-radio :value=1>承認済のみ</b-form-radio>
        </b-form-radio-group>
      </div>
    </div>
    <main style="max-height: calc(100svh - 110px - 100px - 55px);">
      <div class="WorkM_MainArea">
        <b-container fluid style="max-width: 700px;">
          <!-- 一覧 -->
          <div class="WorkM_OwnApplicationList">
            <div class="mt-3">
              <div v-for="approvalItem in approvalList" :key="approvalItem.detailNo">
                <div class="WorkM_OwnApplicationItem" @click="openApplicationEditModal(0, approvalItem)">
                  <!--リスト左側-->
                  <div class="WorkM_OwnApplicationItem_HeaderArea">
                    <div 
                    class="SegmentLabel"
                    :class="[
                      { WorkInfoItem_WorkTimeArea_Red: !isAttendanceCheck(approvalItem.applicationKbn)},
                    ]"
                    style="font-size: 0.9rem; min-width:5rem"
                    >
                      {{ getDispSegment(approvalItem.applicationKbn) }}
                    </div>
                    <div style="margin-top: 6px; margin-bottom: 6px; font-size: 1rem;">
                      <div v-if="approvalItem.approvalKbn == 1" class="ApprovalLabel">
                        <div class="WorkContent_ItemTypeArea_TypeLabel text-center ApprovalIcon_Label mx-auto px-0">承認</div>
                        <div v-if="approvalItem.approvalDate != null && approvalItem.approvalDate != '' && false">
                          {{ approvalItem.approvalDate }}
                        </div>
                      </div>
                      <div v-else-if="approvalItem.approvalKbn == 9" class="RejectionLabel">
                        <div class="WorkContent_ItemTypeArea_TypeLabel text-center RejectionIcon_Label mx-auto px-0">否認</div>
                        <div v-if="approvalItem.approvalDate != null && approvalItem.approvalDate != '' && false">
                          {{ approvalItem.approvalDate }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--リスト右側-->
                  <div class="WorkM_OwnApplicationItem_DetailArea">
                    <!---->
                    <div class="ApplicationDate ApplicationDateApplicationRegist">
                      <div style="min-width:110px;" class="mr-2">{{ "" + approvalItem.applicationTargetDate + "" }}</div>
                      <div style="min-width:125px;">{{ approvalItem.applicationTargetStartTime + "～" + approvalItem.applicationTargetEndTime }}</div>
                    </div>
                    <!---->
                    <div class="DetailItem">
                      <div>
                        <div class="d-flex">
                          <div v-if="approvalItem.constructionCode != null && approvalItem.constructionCode != ''" class="mr-2">{{ "[" + approvalItem.constructionCode + "]" }}</div>
                          <div v-if="approvalItem.disasterKbn == 1" class="text-danger">災害</div>
                        </div>
                        <div>{{ approvalItem.constructionName }}</div>
                      </div>
                    </div>
                    <div class="DetailItem">
                       <div class="ApplicationRegist_DispReasonArea" v-html="setLineFeedCode(approvalItem.applicationReason)"></div>
                    </div>
                    <!---->
                    <div class="DetailItem DetailItemApplicationRegist border-top border-dark mt-2">
                      <div class="DetailItem_TitleLabel">申請日：</div>
                      <div>{{ getStrMd(approvalItem.applicationDate) }}</div>
                      <div v-if="approvalItem.approvalShainName != null && approvalItem.approvalShainName != ''" class="ml-2">
                        {{ "(" + approvalItem.approvalShainName + ")" }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--フッター-->
            <div class="fixed-bottom px-3 mx-auto" style="margin-bottom: 50px; background-color: #ececec;">
              <div class="WorkM_Button WorkM_AddButton my-2 mx-auto" style="max-width: 700px;" @click="openApplicationEditModal(1, null)">
                <b-icon icon="plus-lg" class="mr-2"></b-icon>追加
              </div>
            </div>
          </div>
        </b-container>
      </div>
    </main>
    <ApplicationEditModal 
    ref="ApplicationEditModal"
    :clickType="clickType"
    :selectApplication="selectApplication"
    @getApplicationRegistInfo="getApplicationRegistInfo"
    ></ApplicationEditModal>
  </div>
</template>

<script>
import ApplicationEditModal from "../components/Modal/ApplicationEditModal.vue";
import config from "../const/config";
export default {
  name: "ApplicationRegist",
  components: { ApplicationEditModal },
  data() {
    return {
      userId: null,
      systemVersion: null,
      loginUserId: null,
      dispDate: null,
      conditionStartDate: new Date(),
      dispDayOfWeek: null,
      dispDateType: null,
      viewApprovalStatus: null,
      approvalList:[],
      clickType: 0,

      shiftStart: null, // シフト開始時刻
      shiftEnd: null, // シフト終了時刻
      sectionLeaderShainCd: 0, // 管理者社員CD
      sectionLeaderShainName: null, // 管理者社員名
      sectionSubLeaderShainCd: 0, // 代理申請先社員CD
      sectionSubLeaderShainName: null, // 代理申請先社員名
      targetDateInfo: {}, // 対象日付情報
      selectApplication: {}, // 申請一覧情報
      applicationRemainInfo: {}, // 申請時各種残日数情報
    };
  },
  computed: {},
  watch: {},
  mounted: function () {
    this.systemVersion = this.$store.getters.getSystemVersion;
    this.loginUserId = this.$store.state.user_id;
    this.loginUserName = this.$store.state.user_name;
    this.dispDate = null;
    // 月間画面から遷移してきたか確認
    if(this.$store.state.is_from_work_calendar){
      console.log("target_date：" + this.$store.state.target_date);
      this.dispDate = this.getStrDateSlash(this.$store.state.target_date);
      let isFromWorkCalendar = {
        is_from_work_calendar: false,
      };
      this.$store.commit("setIsFromWorkCalendar", isFromWorkCalendar);
    }
    this.getApplicationRegistInfo();
  },

  methods: {
    // 押下した箇所に合わせて、開くモーダルのタイトルを変更する
    // clickType:0 申請一覧を押下した際の動作。申請更新モーダルを開く
    // clickType:0以外 追加ボタンを押下した際の動作。申請登録モーダルを開く
    openApplicationEditModal: function (clickType, approvalItem) {
      console.debug("approvalItem：" + JSON.stringify(approvalItem));
      let targetapplicationInfo = {};
      if(clickType == 0){
        targetapplicationInfo = approvalItem;
      }
      else{
        targetapplicationInfo = {
          shainCd: Number(this.loginUserId),
          applicationKbn: 0,
          applicationTargetDate: this.getStrDateSlash(this.targetDateInfo.date),
          applicationTargetStartTime: this.shiftStart,
          applicationTargetEndTime: this.shiftEnd,
          approvalKbn: 0,
          approvalShainCd: (this.sectionSubLeaderShainCd != null && this.sectionSubLeaderShainCd != 0) ? this.sectionSubLeaderShainCd : this.sectionLeaderShainCd,
          approvalShainName: (this.sectionSubLeaderShainCd != null && this.sectionSubLeaderShainCd != 0) ? this.sectionSubLeaderShainName : this.sectionLeaderShainName,
          isApprovalDutyAgent: (this.sectionSubLeaderShainCd != null && this.sectionSubLeaderShainCd != 0) ? 1 : 0,
          workDetailNo:0,
          transferWorkDate:null,
          transferWorkStartDate:null,
          transferWorkEndDate:null,
          transferWorkWorkingTime:null,

          planSubstituteHolidayDate:null,
          planSubstituteHolidayStartTime:null,
          planSubstituteHolidayEndTime:null,

          confirmedDate: null,
          beforeClosedayFlg: 0
        };
      }
      this.clickType = clickType;
      this.selectApplication = {
        shiftStart: this.shiftStart, // シフト開始時刻
        shiftEnd: this.shiftEnd, // シフト終了時刻
        targetDateInfo: this.targetDateInfo,
        applicationInfoList: targetapplicationInfo,
        applicationRemainInfo: this.applicationRemainInfo,
      };
      
      if (targetapplicationInfo.beforeClosedayFlg == 0){
        console.log("selectApplication：" + JSON.stringify(this.selectApplication));
        this.$refs.ApplicationEditModal.openModal();
      }
    },
    getDispSegment: function (segmentCd) {
      let optionSegment = config.OPTIONS.APPLICATION_SEGMENT_SIMPLE;
      let result = "";
      optionSegment.forEach((element) => {
        if (element.value == segmentCd) {
          result = element.text;
        }
      });
      return result;
    },
    getApplicationRegistInfo: function(){
      this.getApplicationRegistInfoFromAPI();
    },
    getApplicationRegistInfoFromAPI: function(){
      let paramList = {
          shainCd: this.loginUserId,
          targetDate: this.dispDate,
          applicationKbn: this.viewApprovalStatus,
      }
      console.debug(JSON.stringify(paramList));
      this.getWithParams(config.URL.APPLICATION_REGIST, paramList)
        .then((response) => {
          if(response.result){
            console.debug("response：" + JSON.stringify(response.container));
            this.isErrorGetShfitFlg = false;
            this.setApplicationRegistInfo(response.container);
          }
          else{
            this.isErrorGetShfitFlg = true;
            this.showAlertError(response.message);
          }
        })
        .catch((e) => {
          // Note: エラーメッセージは、共通処理で表示している
          console.error(e);
        })
        .finally(() => {});
    },
    // APIから取得したデータをセット
    setApplicationRegistInfo: function(items){
      this.shiftStart = items.shiftStart;
      this.shiftEnd = items.shiftEnd;

      this.sectionLeaderShainCd = items.sectionLeaderShainCd;
      this.sectionLeaderShainName = items.sectionLeaderShainName;

      this.sectionSubLeaderShainCd = items.sectionSubLeaderShainCd;
      this.sectionSubLeaderShainName = items.sectionSubLeaderShainName;

      this.targetDateInfo = items.targetDateInfo;
      this.approvalList = items.applicationInfoList;
      this.applicationRemainInfo = items.applicationRemainInfo;
      
      this.dispDate = this.getStrDateSlash(items.targetDateInfo.date);
      this.dispDayOfWeek = this.getDayOfWeek(this.dispDate);
      this.dispDateType = items.targetDateInfo.dateType;
    },
    // 出勤しているかチェックする
    // true：出勤
    // false：休み
    isAttendanceCheck: function(applicationKbn){
      const WORK_SEGMENT_EARLY_START = 1; // 早出
      const WORK_SEGMENT_OVERTIME = 2; // 残業
      const WORK_SEGMENT_HOLIDAY_TRANSFER = 11; // 休日出勤（振替）
      const WORK_SEGMENT_HOLIDAY_ALLOWANCE = 12; // 休日出勤（残業）
      const WORK_SEGMENT_PUBLIC_HOLIDAY_TRANSFER = 21; // 公休出勤（振替）
      const WORK_SEGMENT_PUBLIC_HOLIDAY_ALLOWANCE = 22; // 公休出勤（残業）
      
      if(applicationKbn != WORK_SEGMENT_EARLY_START
      && applicationKbn != WORK_SEGMENT_OVERTIME 
      && applicationKbn != WORK_SEGMENT_HOLIDAY_TRANSFER 
      && applicationKbn != WORK_SEGMENT_HOLIDAY_ALLOWANCE 
      && applicationKbn != WORK_SEGMENT_PUBLIC_HOLIDAY_TRANSFER 
      && applicationKbn != WORK_SEGMENT_PUBLIC_HOLIDAY_ALLOWANCE 
      && applicationKbn > 0){
        return false;
      }
      else{
        return true;
      }
    },
    // 表示されている日付の1日前の申請一覧を表示する
    clickBeforeDate: function () {
      this.dispDate = this.getBeforeDate(this.dispDate);
      this.dispDate = this.getStrDateSlash(this.dispDate);
      this.dispDayOfWeek = this.getDayOfWeek(this.dispDate);
      this.getApplicationRegistInfo(this.dispDate);
    },
    // 表示されている日付の1日後の申請一覧を表示する
    clickNextDate: function () {
      this.dispDate = this.getNextDate(this.dispDate);
      this.dispDate = this.getStrDateSlash(this.dispDate);
      this.dispDayOfWeek = this.getDayOfWeek(this.dispDate);
      this.getApplicationRegistInfo(this.dispDate);
    },
    // 空文字かチェック
    // true: 空文字
    // false: 空文字ではない
    emptyCheck(text){
      if(text != null && text != ""){
        return false;
      }
      else{
        return true;
      }
    },
    // 事由 改行コードを<br>にする
    setLineFeedCode: function(msg){
      let newMsg = msg?.replace(/\n/g,'<br>');
      return newMsg;
    }
  },
};
</script>
<style>
.DispYearMonthDateApplicationRegist{
  font-size: 1.1rem; 
  white-space: nowrap;
  text-align:center;
}
.ApplicationDateApplicationRegist{
  flex-wrap:wrap;
}
.DetailItemApplicationRegist{
  flex-wrap:wrap;
}
/* 日時表示エリア */
.AplicationRegist_DispDateArea {
  justify-content: space-around;
  font-size: 1rem;
  width: 100%;
  text-align: center;
  background: #ececec;
  border-bottom: 1px solid rgb(241, 241, 241);
  padding: 0.3rem;
  padding-right: 3rem;
  padding-left: 3rem;
  font-size: 1.2rem;
}
.workCalendarIcon {
  position: absolute;
  right:0px;
}
/* 検索条件エリア */
.WorkM_OwnApplicationListCondition {
    background-color: #f8f8f8;
    font-size: 0.8rem;
}
/* 申請一覧エリア */
.WorkM_OwnApplicationList {
  padding: 0 1rem;
}

.ConditionStartDate {
  width: 280px;
}
.WorkM_OwnApplicationItem {
  display: flex;
  margin-bottom: 0.7rem;
  background: rgb(227, 227, 227);
  box-shadow: 2px 2px 3px rgb(230, 230, 230);
  border-radius: 5px;
  height: 100%;
}
.WorkM_OwnApplicationItem_HeaderArea {
  height: 100%;
  width: 5rem;
}
.SegmentLabel {
  padding: 4px;
  width: 100%;
  background: rgb(24, 103, 194);
  color: rgb(255, 255, 255);
  font-weight: 700;
  border-radius: 5px 0 0 0;
  min-width: 4rem;
  text-align: center;
}

.WorkM_OwnApplicationItem_DetailArea {
  padding: 0.1rem 0.5rem;
  padding-top:0;
  flex-grow: 1;
  background: #f5f5f5;
}
.WorkM_OwnApplicationItem_DetailArea .ApplicationDate {
  font-size: 1.1rem;
  display: flex;
  font-weight: 700;
}
.WorkM_OwnApplicationItem_DetailArea .DetailItem {
  display: flex;
  font-size: 0.95rem;
}
.WorkM_OwnApplicationItem_DetailArea .DetailItem .ApplicationRegist_DispReasonArea {
  word-break: break-all;
}

.WorkM_AddButton {
  width: 100%;
  padding: 0.4rem !important;
  text-align: center;
  background: rgb(253, 253, 253);
  border: 1px solid rgb(216, 216, 216);
  color: rgb(83, 83, 83);
  border-radius: 5px;
  margin: 0.5rem 0;
  font-weight: 700;
}

.ApprovalIcon_Circle {
  background-color: rgb(29, 116, 50);
  color: white;
  width: 30px;
  height: 30px;
  line-height: 30px;
  border-radius: 50%;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
}
.RejectionIcon_Circle {
  background-color: red;
  color: white;
  width: 30px;
  height: 30px;
  line-height: 30px;
  border-radius: 50%;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
}

.ApprovalLabel {
  text-align: center;
  color:rgb(20, 78, 34);
}
.ApprovalIcon_Label {
  background-color: transparent !important;
  color: rgb(20, 78, 34) !important;
  border:1px solid rgb(20, 78, 34) !important;
  max-width:60px;
}
.RejectionLabel{
  text-align: center;
  color:red;
}
.RejectionIcon_Label {
  background-color: transparent !important;
  color: red !important;
  border:1px solid red !important;
  max-width:60px;
}
</style>
